'use strict';

var debounce = require('lodash/debounce');

var endpoint = $('.suggestions-wrapper').data('url');
var minChars = 3;
var searchedWord;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
const FOCUSABLE = 'button:not(:disabled):not([aria-hidden]),a[href],input';
/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.js-suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.js-suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .js-suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
/*
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
} */

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.js-suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    $('.js-no-suggestions').hide();
    $('.js-suggestions').show();
    // $.spinner().stop();

    if (!(typeof (response) === 'object')) {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-sm-block');
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            // toggleSuggestionsIcon('close');
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.js-suggestions .item');
        $('#sr-search-suggestions-ready-desktop').text($('#js-sr-searchsuggestionsready-desktop').val());
        $('#sr-search-suggestions-ready-mobile').text($('#js-sr-searchsuggestionsready-mobile').val());
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        $('#sr-search-suggestions-ready-desktop').empty();
        $('#sr-search-suggestions-ready-mobile').empty();
    }
    $('body').trigger('suggestion:productAnalytics');
}

function specialCharChecker(toCheck) {
    const forbiddenChar = ['<', '>', '&', '%', '(', ')', '|', '!', '$', '^', '`', '?'];
    const errorFieldDesktop = $('#search-assistive-text-desktop .cc-error-message');
    const errorFieldMobile = $('#search-assistive-text-mobile .cc-error-message');
    const jsSearchControlSelector = $('.js-search-control');

    var isValid = true;

    forbiddenChar.forEach(element => {
        if (toCheck.indexOf(element) !== -1) {
            isValid = false;
            return true;
        }
    });

    function updateErrorField($errorField) {
        if (!isValid && toCheck.length > 0) {
            if ($errorField.hasClass('d-none')) $errorField.removeClass('d-none');
            jsSearchControlSelector.attr('data-isvalid', 'false');
        } else {
            if (!$errorField.hasClass('d-none')) $errorField.addClass('d-none');
            jsSearchControlSelector.attr('data-isvalid', 'true');
        }
    }

    updateErrorField(errorFieldDesktop);
    updateErrorField(errorFieldMobile);
    
    return isValid;
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    var searchWord = $(scope).val();
    // NEC-3045 add control to special char
    var validChar = specialCharChecker(searchWord);
    if (searchWord.length >= minChars && searchWord !== searchedWord && validChar) {
        searchedWord = searchWord;
        // $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent(searchWord),
            method: 'GET',
            success: processResponse,
            error: function () {
                // $.spinner().stop();
            }
        });
    } else {
        // $('.js-no-suggestions').show();
        // // toggleSuggestionsIcon('search');
        // $(scope).siblings('.reset-button').removeClass('d-sm-block');
        // clearModals();
        // getSuggestionsWrapper(scope).empty();
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.js-suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    if (showMoreUrl) {
        // $.spinner().start();
        $.ajax({
            url: showMoreUrl,
            method: 'GET',
            success: function (response) {
                $target.append(response);
                // $.spinner().stop();
            },
            error: function () {
                // $.spinner().stop();
            }
        });
    }
}

function closeSearch() {

    $('#sr-search-suggestions-ready-desktop').empty();
    $('#sr-search-suggestions-ready-mobile').empty();
    $('.cc-search-section').hide();
    $('.js-site-search').hide();
    $('.js-no-suggestions').hide();
    $('.js-suggestions').hide();

    $('body').removeClass('cc-megamenu-open');
    if ($('body').hasClass('cc-blocked')) {
        // prevent body blocked when search is open with menu already open
        $('body').removeClass('cc-blocked');
    }
    $('.id-js-searchIcon').data('open', false).removeClass('cc-search-open');
    var $searchButton = $('.id-js-searchIcon button');
    $searchButton.attr('aria-expanded', 'false');

    // Analytics
    $('body').trigger('analytics:dataLayerPushObj', {
        event: 'search_layer',
        layer_action: 'close'
    });
}

function openSearch() {
    const searchSection = $('.cc-search-section');
    searchSection.show();
    $('.js-site-search').show();
    var isFill = ($(document).find('input.search-field').val() !== '');
    if (isFill) {
        $('.js-suggestions').show();
    } else {
        $('.js-no-suggestions').show();
        searchedWord = '';
    }
    $('body').addClass('cc-megamenu-open');
    $('.id-js-searchIcon').data('open', true).addClass('cc-search-open');
    var $searchButton = $('.id-js-searchIcon button');
    $searchButton.attr('aria-expanded', 'true');

    searchSection.find('input').focus();

    searchSection.on('keydown', function(event) {
        let focusableNodes = searchSection.find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
        const key = event.which;
        const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
        if (event.shiftKey && focusedItemIndex === 0) {
            focusableNodes[focusableNodes.length - 1].focus();
            event.preventDefault();
        }
        if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1 && key === 9) {
            focusableNodes[0].focus();
            event.preventDefault();
        }
        if (key === 27) { // close search overlay and focus on serch icon
            closeSearch();
            $('.id-js-searchIcon button').focus();
        }
    });

    // Analytics
    $('body').trigger('analytics:dataLayerPushObj', {
        event: 'search_layer',
        layer_action: 'open'
    });
}

module.exports = function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        if ($(document).find('.js-search-control').data('isvalid') === 'false') {
            e.stopPropagation();
            e.preventDefault();
        } else {
            // event moved here from keyup on search-field because it checked only enter key -> same as submit and it didn't work on submit for other prevent default
            // send analytics internal search
            var val = $(this).find('.search-field').val();

            // analytics
            dataLayer.push({
                event: 'internalSearch',
                eventCategory: 'Internal Search',
                eventAction: 'Tips',
                eventLabel: val
            });
        }
        var suggestionsList = $('.js-suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 600);
        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
            case DOWN_KEY:
                handleArrow(DIRECTION_DOWN);
                e.preventDefault(); // prevent moving the cursor
                break;
            case UP_KEY:
                handleArrow(DIRECTION_UP);
                e.preventDefault(); // prevent moving the cursor
                break;
            default:
                debounceSuggestions(this, e);
            }
        });
    });

    // $('body').on('click', function (e) {
    //     if (!$('.js-suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
    //         $('.js-suggestions').hide();
    //     }
    // });

    /*
    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.js-suggestions').hide();
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
        closeSearch();
    });
    */

    $('#product-tab').on('keypress click', function (e) {
        if (e.type === 'click' || (e.type === 'keypress' && e.key === 'Enter')) {
            setTimeout(function() {
                $('.show-filter-text').focus(); // Adding focus for accessibility
            }, 100); // Delay of 100ms to allow the element to appear
        }
    });

    $('#articles-tab').on('keypress click', function (e) {
        if (e.type === 'click' || (e.type === 'keypress' && e.key === 'Enter')) {
            var firstLink = $('#content-search-results a:first');
            setTimeout(function() {
                $(firstLink).focus(); // Adding focus for accessibility
            }, 100); // Delay of 100ms to allow the element to appear
        }
    });


    $('.js-site-search .reset-button').on('click', function () {
        $(this).removeClass('d-sm-block');
    });

    $('body').on('click', '.id-js-searchIcon', function(e) {
        var wasOpen = false;
        if ($('.id-js-searchIcon').data('open')) {
            wasOpen = true;
        }

        if (wasOpen) {
            closeSearch();
            if (window.isMobile) {
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    display: 'block',
                    visibility: 'visible'
                });
            }
        } else {
            openSearch();
            if (window.isMobile || window.isTabletPortrait) {
                if ($('.cc-navbar').hasClass('cc-open')) {
                    $('.cc-navbar').removeClass('cc-open');
                    $('.cc-mobile .cc-navbar').css('display', 'none');
                    $('.cc-tablet-portrait .cc-navbar').css('display', 'none');
                    $('.cc-button-menu-mobile').removeClass('cc-open').attr('aria-label', $('#js-openmenu-label').val());
                }
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    display: 'none',
                    visibility: 'hidden'
                });
            } else $('.js-menu-overlay').addClass('d-none');
        }

        // close share section if is open
        if ($('.cc-mobile .cc-product-detail .cc-share-button-share').is(':visible') || $('.cc-tablet-portrait .cc-product-detail .cc-share-button-share').is(':visible')) {
            $('.cc-mobile-content-share').css('display', 'none');
            $('.cc-sticky-add-to-cart').css('display', 'unset');
            $('.cc-share-button-share').removeClass('cc-share-background-overlay');
            $('body').css('overflow', 'auto');
        }
    });

    $('body').on('click', '.id-js-searchClose', function(e) {
        closeSearch();
        if (window.isMobile) {
            $('.helpButton, #embeddedMessagingConversationButton').css({
                display: 'block',
                visibility: 'visible'
            });
        }
    });

    $('body').on('click', function (event) {
        var $target = $(event.target);
        if (!$target.closest('.id-js-search-container').length && $('.id-js-searchIcon').data('open')) {
            closeSearch();
            if (window.isMobile) {
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    display: 'block',
                    visibility: 'visible'
                });
            }
        }
    });

    // Display content results from the search
    $('body').on('click', '.container .content-search', function () {
        if ($('#content-search-results').html() === '') {
            getContent($(this), $('#content-search-results'));
        }
    });

    // go to selected suggested page
    $('body').on('click', '.js-content-terms', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        window.location.href = href;
    });

    // Display the next page of content results from the search
    /*
    $('body').on('click', '.container .show-more-content button', function () {
        getContent($(this), $('#content-search-results'));
        $('.show-more-content').remove();
    });
    */
    var notPushed = true;
    // search-analytics
    $(document).on('click', '.js-search-analytics-ideas', function (e) {

        var val = $(this).find('a').text();

        // analytics
        if (notPushed) {
            dataLayer.push({
                event: 'internalSearch',
                eventCategory: 'Internal Search',
                eventAction: 'Ideas',
                eventLabel: val
            });
            notPushed = false;
        }
        // END
    });

    $(document).on('click', '.js-search-analytics-tips', function (e) {

        var val = $(this).attr('aria-label');

        if (val === 'undefined') {
            val = $(this).text();
        }

        // analytics
        dataLayer.push({
            event: 'internalSearch',
            eventCategory: 'Internal Search',
            eventAction: 'Tips',
            eventLabel: val
        });
        // END
    });

    $(document).on('click', '.id-js-searchIcon', function(e) {
        // caricamento contenuto asset
        var url = $('.id-urlSuggestion').val();
        if (window.isMobile || window.isTabletPortrait) {
            var products = $('.cc-only-mobile .js-products-suggested');
            var containerClass = '.cc-only-mobile ';
        } else {
            var products = $('.cc-no-mobile .js-products-suggested');
            var containerClass = '.cc-no-mobile ';
        }

        for (var i = 0; i < products.length; i++) {
            var prod = products[i];
            var pid = $(prod).val();
            var urlTile = 'pid=' + pid;
            var completeUrl = url + '?' + urlTile;
            $.ajax({
                url: completeUrl,
                method: 'GET',
                success: function (data) {
                    if (data) {
                        var tempDiv = document.createElement('div');
                        tempDiv.classList.add('cc-item');
                        tempDiv.innerHTML = data;
                        var returningPid = $(data).data('id');
                        var finalClass = containerClass + '.js-item-append-' + returningPid;
                        $(finalClass).replaceWith(tempDiv);
                        $('body').trigger('suggestion:productAnalytics');
                    }
                },
                error: function(err) {
                    console.log('ERROR');
                }
            });
        }
    });

    $(document).find('.js-contant-suggested-noResult .js-products-suggested').each(function (index) {
        var url = $('.id-urlSuggestion').val();

        var products = $(this);
        var prod = $(this);
        var pid = $(prod).val();
        var urlTile = 'pid=' + pid;
        var completeUrl = url + '?' + urlTile;
        $.ajax({
            url: completeUrl,
            method: 'GET',
            success: function (data) {
                if (data) {
                    var containerClass = '.js-contant-suggested-noResult ';
                    var tempDiv = document.createElement('div');
                    tempDiv.classList.add('cc-item');
                    tempDiv.innerHTML = data;
                    var returningPid = $(data).data('id');
                    var finalClass = containerClass + '.js-item-append-' + returningPid;
                    $(finalClass).replaceWith(tempDiv);
                    $('body').trigger('suggestion:productAnalytics', {
                        container: containerClass
                    });
                }
            },
            error: function(err) {
                console.log('ERROR');
            }
        });
    });
};
